<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: 'sobre',
}
</script>

<style scoped lang="stylus"></style>
